import { Theme } from '@material-ui/core/styles/createMuiTheme';
import withStyles, {
  StyleRules,
  StyleRulesCallback,
  WithStyles,
} from '@material-ui/core/styles/withStyles';
import Tooltip from '@material-ui/core/Tooltip';
import StarHalfIcon from '@serko/zui-icons/es/StarHalfIcon';
import StarIcon from '@serko/zui-icons/es/StarIcon';
import StarOutlineIcon from '@serko/zui-icons/es/StarOutlineIcon';
import Typography from '@serko/zui/es/Typography';
import React, { PureComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import compose from 'recompose/compose';
import messages from '../../intl/messages';
import { AppState } from '../../store/model';
import { isSaviSelectIntl } from '../../store/reducers/itinerary/selectors';
import { connect } from 'react-redux';

interface OwnProps {
  value: number;
  reviewCount?: number;
}

interface StateProps {
  isSaviSelectIntl: boolean;
}

interface StarRatingProps
  extends OwnProps,
    WithStyles<typeof styles>,
    InjectedIntlProps,
    StateProps {}

class StarRatingBase extends PureComponent<StarRatingProps> {
  public render() {
    const {
      reviewCount,
      value,
      classes,
      intl: { formatMessage },
      isSaviSelectIntl,
    } = this.props;

    if (value <= 0) return null;

    return (
      <Tooltip title={`${value} stars`} placement="bottom">
        <Typography variant="caption" inline>
          <span className={classes.stars}>{this.renderStars()}</span>
          {!!reviewCount && !isSaviSelectIntl && (
            <span className={classes.reviews}>
              {formatMessage(messages.common.reviewCount, { reviewCount })}
            </span>
          )}
        </Typography>
      </Tooltip>
    );
  }
  private renderStars = () => {
    return [1, 2, 3, 4, 5].map(this.renderStar);
  };

  private renderStar = (star: number) => {
    const { classes, value } = this.props;
    const Icon = this.getStarIcon(value, star);

    return <Icon className={classes.star} key={star} />;
  };

  private getStarIcon(rating: number, star: number) {
    if (rating >= star) return StarIcon;

    if (rating > star - 1 && rating < star) return StarHalfIcon;

    return StarOutlineIcon;
  }
}

// styled
type ClassKey = 'star' | 'stars' | 'reviews';
const styles: StyleRulesCallback<ClassKey> = ({
  zeno: {
    uiElements: {
      starRating: { default: starRating },
    },
  },
}: Theme): StyleRules<ClassKey> => ({
  reviews: {
    marginLeft: '0.5em',
  },
  star: {
    color: starRating,
    height: 12,
    width: 12,
  },
  stars: {
    alignItems: 'center',
    display: 'inline-flex',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  },
});

const mapStateToProps = (state: AppState) => {
  return {
    isSaviSelectIntl: isSaviSelectIntl(state),
  };
};

const enhance = compose<StarRatingProps, OwnProps>(
  withStyles(styles),
  injectIntl,
  connect(mapStateToProps),
);

export const StarRating = enhance(StarRatingBase);

StarRating.displayName = 'StarRating';
